import XLSX from 'xlsx';

import { CargoArrivalNotice } from './CargoArrivalNotice';

import { DeliveryList } from './DeliveryList';

import { VesselArrivalNotice } from './VesselArrivalNotice';

export function CargoArrivalNoticeExcel(data, user) {
    CargoArrivalNotice(XLSX, data, user)
}

export function DeliveryListExcel(data) {
    DeliveryList(XLSX, data)
}

export function VesselArrivalNoticeExcel(data) {
    VesselArrivalNotice(XLSX, data)
}